import { Box, Typography, Stack, alpha } from "@mui/material";
import { formatAmount } from "../../utils/hooks/dataHandler";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";

const NetProfitSummary = ({ amount }) => {
  const isPositive = amount >= 0;

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      alignItems={{ xs: "stretch", sm: "center" }}
      justifyContent='space-between'
    >
      <Stack direction='row' spacing={2} alignItems='center'>
        <Box
          sx={{
            width: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 2,
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
          }}
        >
          <AccountBalanceWalletOutlinedIcon
            color='primary'
            sx={{ fontSize: 24 }}
          />
        </Box>
        <Box>
          <Typography variant='body2' color='text.secondary' sx={{ mb: 0.5 }}>
            Net Profit / (Loss) before Tax
          </Typography>
          <Typography
            variant='h4'
            sx={(theme) => ({
              color: isPositive
                ? theme.palette.success.main
                : theme.palette.error.main,
              fontWeight: 600,
              transition: "color 0.3s ease",
              display: "flex",
              alignItems: "center",
              gap: 1,
            })}
          >
            {formatAmount(amount, true)}
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
};

export default NetProfitSummary;
